import React from "react";
// import * as ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';

import { createBrowserHistory } from "history";
import { Provider } from "mobx-react";
import { Route, Router, Switch } from "react-router-dom";
import { PageContainer, SystemMessage } from "./components";
import { LocationState, Page, PrivateRoute, privateRoutes, PublicRoute, publicRoutes } from './routes';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { RoutingStore, AuthStore, RootStore } from './stores';
import "./styles/index.scss";
import "./i18n";

export const routingStore = new RoutingStore();
export const authStore    = new AuthStore(routingStore);
export const rootStore    = new RootStore(authStore);

// Create the browserHistory separately to sync it with the routingStore
const browserHistory = createBrowserHistory<LocationState>();
const history        = rootStore.routingStore.syncHistory(browserHistory);

const stores = {
  authStore:      authStore,
  rootStore:      rootStore,
  routingStore:   rootStore.routingStore,
  userStore:      rootStore.userStore,
  spaceStore:     rootStore.spaceStore,
  questionStore:  rootStore.questionStore,
  delivStore:     rootStore.delivStore,
  tagStore:       rootStore.tagStore,
  agendaStore:    rootStore.agendaStore,
  commentStore:   rootStore.commentStore,
  meetingStore:   rootStore.meetingStore,
  fileStore:      rootStore.fileStore,
  itemStores:     rootStore.itemStores,
  milestoneStore: rootStore.milestoneStore,
  logStore:       rootStore.logStore
}

const App = () => {
  return (
    <Provider {...stores}>
      <Router history={history}>
        <PageContainer>
          <DndProvider backend={HTML5Backend}>
            <Switch>
              {publicRoutes.map(r => <PublicRoute {...r} key={r.path as string} />)}
              {privateRoutes.map(r => <PrivateRoute {...r} key={r.path as string} redirectTo={`/${Page.Login}`} />)}
              <Route render={() => <h1>404: page not found</h1>} />
            </Switch>
          </DndProvider>
          <SystemMessage />
        </PageContainer>
      </Router>
    </Provider>
  );
};

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

// ReactDOM.render( <App /> , document.getElementById("root") );

